import { DETECTED_ISSUE_ACTION_CONFIGS } from './constants'
import type { DetectedIssueType } from './types'

export default function hasAutomatedActions(issueType: DetectedIssueType): boolean {
  const { baseActions, strikeActions, penaltyActions } = DETECTED_ISSUE_ACTION_CONFIGS[issueType]
  const actions = [...baseActions, ...strikeActions, ...penaltyActions]

  if (actions.length === 0) {
    return false
  }

  return actions.some(action => {
    if (action.type === 'escalation') {
      return action.shouldSuspend
    }
    if (action.type === 'reporter-message') {
      return false
    }
    return true
  })
}
